function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-a1b4f3d6\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Confirm.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Confirm.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a1b4f3d6\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Confirm.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a1b4f3d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Confirm.vue
// module id = 40
// module chunks = 0